module.exports = __webpack_public_path__ + "img/certificate-IM-4.5-5.5.f5f30d2a.png";